//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

import Swiper from 'swiper/bundle';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { PageUtils } from "./helpers/page-utils";
const _debounce = require('lodash.debounce');

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;

function closeLightBox(lightbox) {
    lightbox.dataset.visible = 'false';

    // Disable smooth scroll during transition
    const docElement = document.documentElement;
    const originalScrollBehavior = docElement.style.scrollBehavior;
    docElement.style.scrollBehavior = 'auto';

    // Custom body unlock for lightbox
    const docBody = document.body;
    docBody.style.position = '';
    docBody.style.top = '';
    docBody.style.width = '';
    docBody.classList.remove('lightbox-open');

    // Restore scroll position
    window.scrollTo(0, lightboxScrollPosition);

    // Re-enable smooth scroll after a brief delay
    setTimeout(() => {
        docElement.style.scrollBehavior = originalScrollBehavior || 'smooth';
    }, 100);

    // Restore scroll-to-top button
    const scrollToTopButton = document.querySelector('button[data-progress-ring]');
    if (scrollToTopButton && scrollToTopButton.dataset.lightboxHidden === 'true') {
        scrollToTopButton.dataset.lightboxHidden = 'false';
        scrollToTopButton.style.display = '';
    }

    setTimeout(() => { lightbox.dataset.hidden = 'true'; }, 300);
}

// Store scroll position for lightbox
let lightboxScrollPosition = 0;

function openLightBox(lightbox) {
    // Store current scroll position
    lightboxScrollPosition = window.scrollY;

    lightbox.dataset.hidden = 'false';

    // Custom body lock for lightbox
    const docBody = document.body;
    docBody.style.top = `-${lightboxScrollPosition}px`;
    docBody.style.position = 'fixed';
    docBody.style.width = '100%';
    docBody.classList.add('lightbox-open');

    // Hide all navigation elements
    document.getElementById('siteHeader').dataset.visible = 'false';
    document.body.dataset.navVisible = 'false';

    // Hide scroll-to-top button
    const scrollToTopButton = document.querySelector('button[data-progress-ring]');
    if (scrollToTopButton) {
        scrollToTopButton.dataset.lightboxHidden = 'true';
        scrollToTopButton.style.display = 'none';
    }

    setTimeout(() => {
        lightbox.dataset.visible = 'true';
    }, 50);
}

function updateNavButtons(swiper, prevEl, nextEl) {
    const prevButton = document.querySelector(prevEl);
    const nextButton = document.querySelector(nextEl);

    if (prevButton && nextButton) {
        prevButton.disabled = swiper.isBeginning;
        nextButton.disabled = swiper.isEnd;

        // Optionally, add/remove opacity styles for better UX
        prevButton.classList.toggle('opacity-50', swiper.isBeginning);
        prevButton.classList.toggle('pointer-events-none', swiper.isBeginning);

        nextButton.classList.toggle('opacity-50', swiper.isEnd);
        nextButton.classList.toggle('pointer-events-none', swiper.isEnd);
    }
}

function documentKeydownHandler(event, lightbox, swiper) {
    if (!lightbox.classList.contains('hidden')) {
        if (event.key === 'Escape') closeLightBox(lightbox);
        else if (event.key === 'ArrowRight') swiper.slideNext();
        else if (event.key === 'ArrowLeft') swiper.slidePrev();
    }
}

function updateProgressBar(swiper, lightbox) {
    const progressBar = lightbox.querySelector('.swiper-progress-bar');
    if (progressBar && swiper.slides.length > 1) {
        const progress = (swiper.activeIndex / (swiper.slides.length - 1)) * 100;
        progressBar.style.width = `${progress}%`;
    }
}

window.addEventListener('load', () => {
    const swiperElementsPresent = !!document.querySelector('.swiper');

    const gallerySliderPanel = document.querySelectorAll('.media-panel.media-image-gallery-slider');
    const galleryGridPanel = document.querySelectorAll('.media-panel.media-image-gallery-grid');
    const cardPanel = document.querySelectorAll('.card-panel-slider');
    const cardSliderToGridPanel = document.querySelectorAll('.card-panel-slider-to-grid');
    const testimonialSliderPanel = document.querySelectorAll('.testimonial-panel-slider');
    const testimonialFaderPanel = document.querySelectorAll('.testimonial-panel-fader');

    if (swiperElementsPresent) {

        // START CARD PANEL SLIDER TO GRID
        for (const panel of cardSliderToGridPanel) {
            const container = panel.querySelector('[data-swiper-type="card-slider-to-grid"]');
            const swiperControls = panel.querySelector('[data-swiper-controls]');

            if (container) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = container.dataset.paginationBackgroundColor;
                const paginationBorderColor = container.dataset.paginationBorderColor;
                const autoplay = container.dataset.autoPlay === "true";
                const swiperIndex = container.dataset.swiperIndex;
                const gridCols = container.dataset.gridCols || '';
                const maxGridWidth = container.dataset.maxGridWidth || '';
                const nextEl = `button[data-swiper-go-next="card-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="card-slider-${swiperIndex}"]`;

                let cardSwiper;
                const swiperWrapper = container.querySelector('.swiper-wrapper');

                function initSliderToGrid() {
                    const isDesktop = window.innerWidth >= 1024;

                    if (isDesktop) {
                        // Desktop: Destroy swiper, transform to grid
                        if (cardSwiper) {
                            cardSwiper.destroy(true, true);
                            cardSwiper = null;
                        }

                        // Remove swiper classes
                        container.classList.remove('swiper', 'overflow-visible');

                        // Add grid classes
                        container.classList.add('flex', 'flex-col', 'gap-8', 'lg:gap-12', 'w-full');

                        // Add grid column classes from data attribute
                        if (gridCols) {
                            const gridClasses = gridCols.trim().split(' ');
                            gridClasses.forEach(cls => {
                                if (cls) container.classList.add(cls);
                            });
                        }

                        // Add max width classes from data attribute
                        if (maxGridWidth) {
                            const widthClasses = maxGridWidth.trim().split(' ');
                            widthClasses.forEach(cls => {
                                if (cls) container.classList.add(cls);
                            });
                        }

                        // Remove swiper-wrapper class, make it a regular flex container
                        if (swiperWrapper) {
                            swiperWrapper.classList.remove('swiper-wrapper');
                            swiperWrapper.classList.add('contents');
                        }

                        // Remove swiper-slide classes from children
                        const slides = container.querySelectorAll('.swiper-slide');
                        slides.forEach(slide => {
                            slide.classList.remove('swiper-slide', 'h-auto');
                        });

                        // Hide swiper controls
                        if (swiperControls) {
                            swiperControls.classList.add('hidden');
                        }
                    } else {
                        // Mobile/Tablet: Transform to swiper

                        // Remove grid classes
                        container.classList.remove('flex', 'flex-col', 'gap-8', 'lg:gap-12');

                        // Remove grid column classes
                        if (gridCols) {
                            const gridClasses = gridCols.trim().split(' ');
                            gridClasses.forEach(cls => {
                                if (cls) container.classList.remove(cls);
                            });
                        }

                        // Remove max width classes
                        if (maxGridWidth) {
                            const widthClasses = maxGridWidth.trim().split(' ');
                            widthClasses.forEach(cls => {
                                if (cls) container.classList.remove(cls);
                            });
                        }

                        // Add swiper classes back
                        container.classList.add('swiper', 'w-full', 'overflow-visible');

                        // Restore swiper-wrapper
                        if (swiperWrapper) {
                            swiperWrapper.classList.remove('contents');
                            swiperWrapper.classList.add('swiper-wrapper');
                        }

                        // Restore swiper-slide classes
                        const children = swiperWrapper ? swiperWrapper.children : [];
                        Array.from(children).forEach(child => {
                            child.classList.add('swiper-slide', 'h-auto');
                        });

                        // Show swiper controls
                        if (swiperControls) {
                            swiperControls.classList.remove('hidden');
                        }

                        // Initialize swiper if not already initialized
                        if (!cardSwiper) {
                            cardSwiper = new Swiper(container, {
                                loop: false,
                                speed: 750,
                                direction: 'horizontal',
                                allowTouchMove: true,
                                autoplay: autoplay ?
                                    {
                                        delay: 10000,
                                        disableOnInteraction: false
                                    } : false,
                                slidesPerView: mobileSlidePerPage,
                                slidesPerGroup: 1,
                                spaceBetween: 24,
                                centeredSlides: false,
                                pagination: {
                                    el: `[data-swiper-pagination="card-slider-${swiperIndex}"]`,
                                    clickable: true,
                                    renderBullet: function (index, className) {
                                        return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                                    },
                                },
                                navigation: {
                                    nextEl: nextEl,
                                    prevEl: prevEl,
                                },
                                breakpoints: {
                                    640: {
                                        slidesPerView: mobileSlidePerPage,
                                        spaceBetween: 24,
                                    },
                                    768: {
                                        slidesPerView: tabletSlidePerPage,
                                        spaceBetween: 24,
                                    },
                                },
                            });

                            cardSwiper.on('reachBeginning reachEnd slideChange', function () {
                                updateNavButtons(cardSwiper, prevEl, nextEl);
                            });
                            updateNavButtons(cardSwiper, prevEl, nextEl);
                        }
                    }
                }

                // Initialize on load
                initSliderToGrid();

                // Handle resize with debounce
                const handleResize = _debounce(() => {
                    initSliderToGrid();
                }, 250);

                window.addEventListener('resize', handleResize);
            }
        }
        // END CARD PANEL SLIDER TO GRID

        // START CARD PANEL SLIDER
        for (const panel of cardPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="card-slider"]');

            if (swiperElement) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="card-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="card-slider-${swiperIndex}"]`;

                const cardSwiper = new Swiper(swiperElement, {
                    loop: false,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: mobileSlidePerPage,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    pagination: {
                        el: `[data-swiper-pagination="card-slider-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: mobileSlidePerPage,
                            spaceBetween: 24,
                        },
                        768: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 32,
                        },
                        1280: {
                            slidesPerView: 3,
                            spaceBetween: 32,
                        },
                    },
                });

                cardSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(cardSwiper, prevEl, nextEl);
                });
                updateNavButtons(cardSwiper, prevEl, nextEl);
            }
        }
        // END CARD PANEL SLIDER

        // START GALLERY SLIDER PANEL
        for (const panel of gallerySliderPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="gallery-slider"]');

            if (swiperElement) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const destroySwiperDesktop = swiperElement.dataset.destroySwiperDesktop === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;

                const galleryThumbnails = swiperElement.querySelectorAll('.gallery-panel-image');
                const lightbox = document.querySelector('[data-lightbox="media-image-gallery-slider-panel-' + swiperIndex + '"]');
                const swiperElementLightbox = lightbox ? lightbox.querySelector('.swiper[data-swiper-type="gallery-lightbox-slider"]') : null;
                const nextEl = `button[data-swiper-go-next="gallery-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="gallery-slider-${swiperIndex}"]`;

                let gallerySwiper;
                let galleryLightboxSwiper;

                function initSwipers() {
                    if (window.innerWidth >= 1024 && destroySwiperDesktop) {
                        if (gallerySwiper) {
                            gallerySwiper.destroy(true, true);
                            gallerySwiper = null;
                        }
                    } else {
                        if (!gallerySwiper) {
                            gallerySwiper = new Swiper(swiperElement, {
                                loop: false,
                                speed: 350,
                                direction: 'horizontal',
                                allowTouchMove: true,
                                resistanceRatio: 0,
                                autoplay: autoplay ? { delay: 10000, disableOnInteraction: false } : false,
                                slidesPerView: mobileSlidePerPage,
                                slidesPerGroup: 1,
                                spaceBetween: 24,
                                pagination: {
                                    el: `[data-swiper-pagination="gallery-slider-${swiperIndex}"]`,
                                    clickable: true,
                                    renderBullet: function (index, className) {
                                        return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                                    },
                                },
                                navigation: { nextEl: nextEl, prevEl: prevEl },
                                breakpoints: {
                                    640: { slidesPerView: mobileSlidePerPage, spaceBetween: 24 },
                                    768: { slidesPerView: tabletSlidePerPage, spaceBetween: 24 },
                                    1280: { slidesPerView: 3, spaceBetween: 32 },
                                },
                            });

                            gallerySwiper.on('reachBeginning reachEnd slideChange', function () {
                                updateNavButtons(gallerySwiper, prevEl, nextEl);
                            });
                            updateNavButtons(gallerySwiper, prevEl, nextEl);
                        }
                    }
                }

                if (!!lightbox && !!swiperElementLightbox) {
                    // Store lightbox swiper element for later initialization
                }

                initSwipers();

                const handleResize = _debounce(() => {
                    initSwipers();
                }, 300);

                window.addEventListener("resize", handleResize);

                // Setup lightbox functionality
                if (lightbox) {
                    const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');
                    const lightboxClose = lightbox.querySelector('[data-lightbox-close]');

                    // Close lightbox handlers
                    if (lightboxBackdrop) {
                        lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
                    }
                    if (lightboxClose) {
                        lightboxClose.addEventListener('click', () => closeLightBox(lightbox));
                    }

                    // Keyboard navigation (escape to close, arrows to navigate)
                    document.addEventListener('keydown', (event) => {
                        documentKeydownHandler(event, lightbox, galleryLightboxSwiper);
                    });
                }

                let syncing = false;

                if (galleryLightboxSwiper && gallerySwiper) {
                    galleryLightboxSwiper.on('slideChange', function () {
                        if (!syncing) {
                            syncing = true;
                            gallerySwiper.slideToLoop(galleryLightboxSwiper.realIndex, 0, false);
                            syncing = false;
                        }
                    });
                }

                galleryThumbnails.forEach(thumbnail => {
                    thumbnail.addEventListener('click', () => {
                        const slideIndex = parseInt(thumbnail.dataset.slide);

                        if (lightbox) {
                            // Initialize lightbox swiper if not already done
                            if (!galleryLightboxSwiper) {
                                // Temporarily make lightbox visible for proper slide detection
                                lightbox.style.visibility = 'hidden'; // Hidden but takes up space
                                lightbox.style.display = 'flex';
                                lightbox.classList.remove('hidden');
                                galleryLightboxSwiper = new Swiper(swiperElementLightbox, {
                                    effect: 'slide',
                                    // fadeEffect: { crossFade: false },
                                    speed: 750,
                                    loop: false,
                                    centeredSlides: true,
                                    resistanceRatio: 0,
                                    autoplay: false,
                                    allowTouchMove: true,
                                    slidesPerView: 1,
                                    spaceBetween: 0,
                                    width: null, // Let swiper calculate width
                                    watchOverflow: true,
                                    keyboard: {
                                        enabled: true,
                                        onlyInViewport: false,
                                    },
                                    navigation: {
                                        nextEl: lightbox.querySelector('.swiper-button-next'),
                                        prevEl: lightbox.querySelector('.swiper-button-prev'),
                                    },
                                    on: {
                                        init: function() {
                                            updateProgressBar(this, lightbox);

                                            // Hide lightbox again after initialization
                                            lightbox.style.visibility = '';
                                            lightbox.style.display = '';
                                            // Don't add hidden class back - let the data attributes control visibility
                                        },
                                        slideChange: function() {
                                            updateProgressBar(this, lightbox);
                                        }
                                    }
                                });
                            }

                            galleryLightboxSwiper.slideTo(slideIndex, 0);
                            openLightBox(lightbox);
                        }
                    });
                });
            }
        }
        // END GALLERY SLIDER PANEL

        // START GALLERY GRID PANEL
        for (const panel of galleryGridPanel) {
            const container = panel.querySelector('.swiper[data-swiper-type="gallery-grid-slider"]');
            const swiperControls = panel.querySelector('[data-swiper-controls]');

            if (container) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = container.dataset.paginationBackgroundColor;
                const paginationBorderColor = container.dataset.paginationBorderColor;
                const autoplay = container.dataset.autoPlay === "true";
                const destroySwiperDesktop = container.dataset.destroySwiperDesktop === "true";
                const swiperIndex = container.dataset.swiperIndex;

                const galleryThumbnails = container.querySelectorAll('.gallery-panel-image');
                const lightbox = document.querySelector('[data-lightbox="media-image-gallery-grid-panel-' + swiperIndex + '"]');
                const swiperElementLightbox = lightbox ? lightbox.querySelector('.swiper[data-swiper-type="gallery-grid-lightbox-slider"]') : null;
                const gridCols = container.dataset.gridCols || '';
                const nextEl = `button[data-swiper-go-next="gallery-grid-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="gallery-grid-slider-${swiperIndex}"]`;

                let gallerySwiper;
                let galleryLightboxSwiper;
                const swiperWrapper = container.querySelector('.swiper-wrapper');

                function initSliderToGrid() {
                    const isDesktop = window.innerWidth >= 1024;

                    if (isDesktop && destroySwiperDesktop) {
                        // Desktop: Destroy swiper, transform to grid
                        if (gallerySwiper) {
                            gallerySwiper.destroy(true, true);
                            gallerySwiper = null;
                        }

                        // Remove swiper classes
                        container.classList.remove('swiper', 'overflow-visible');

                        // Add grid classes
                        container.classList.add('w-full');

                        // Add grid column classes from data attribute
                        if (gridCols) {
                            const gridClasses = gridCols.trim().split(' ');
                            gridClasses.forEach(cls => {
                                if (cls) container.classList.add(cls);
                            });
                        }

                        // Add gap for grid
                        container.classList.add('gap-4');

                        // Remove swiper-wrapper class, make it a regular container
                        if (swiperWrapper) {
                            swiperWrapper.classList.remove('swiper-wrapper');
                            swiperWrapper.classList.add('contents');
                        }

                        // Remove swiper-slide classes and add grid item classes
                        const slides = container.querySelectorAll('.swiper-slide');
                        slides.forEach(slide => {
                            slide.classList.remove('swiper-slide');
                            slide.classList.add('break-inside-avoid', 'mb-4');

                            // Apply desktop aspect ratio
                            const imageContainer = slide.querySelector('.gallery-panel-image');
                            if (imageContainer && imageContainer.dataset.desktopRatio) {
                                const desktopRatio = imageContainer.dataset.desktopRatio.trim();
                                if (desktopRatio) {
                                    imageContainer.classList.add(desktopRatio);
                                }
                            }
                        });

                        // Hide swiper controls
                        if (swiperControls) {
                            swiperControls.classList.add('hidden');
                        }
                    } else {
                        // Mobile/Tablet: Transform to swiper

                        // Remove grid classes
                        container.classList.remove('gap-4');
                        if (gridCols) {
                            const gridClasses = gridCols.trim().split(' ');
                            gridClasses.forEach(cls => {
                                if (cls) container.classList.remove(cls);
                            });
                        }

                        // Add swiper classes back
                        container.classList.add('swiper', 'w-full', 'overflow-visible');

                        // Restore swiper-wrapper
                        if (swiperWrapper) {
                            swiperWrapper.classList.remove('contents');
                            swiperWrapper.classList.add('swiper-wrapper');
                        }

                        // Restore swiper-slide classes
                        const children = swiperWrapper ? swiperWrapper.children : [];
                        Array.from(children).forEach(child => {
                            child.classList.add('swiper-slide');
                            child.classList.remove('break-inside-avoid', 'mb-4');

                            // Remove desktop aspect ratio
                            const imageContainer = child.querySelector('.gallery-panel-image');
                            if (imageContainer && imageContainer.dataset.desktopRatio) {
                                const desktopRatio = imageContainer.dataset.desktopRatio.trim();
                                if (desktopRatio) {
                                    imageContainer.classList.remove(desktopRatio);
                                }
                            }
                        });

                        // Show swiper controls
                        if (swiperControls) {
                            swiperControls.classList.remove('hidden');
                        }

                        // Initialize swiper if not already initialized
                        if (!gallerySwiper) {
                            gallerySwiper = new Swiper(container, {
                                loop: false,
                                speed: 350,
                                direction: 'horizontal',
                                allowTouchMove: true,
                                resistanceRatio: 0,
                                autoplay: autoplay ? { delay: 10000, disableOnInteraction: false } : false,
                                slidesPerView: mobileSlidePerPage,
                                slidesPerGroup: 1,
                                spaceBetween: 24,
                                pagination: {
                                    el: `[data-swiper-pagination="gallery-grid-slider-${swiperIndex}"]`,
                                    clickable: true,
                                    renderBullet: function (index, className) {
                                        return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                                    },
                                },
                                navigation: { nextEl: nextEl, prevEl: prevEl },
                                breakpoints: {
                                    640: { slidesPerView: mobileSlidePerPage, spaceBetween: 24 },
                                    768: { slidesPerView: tabletSlidePerPage, spaceBetween: 24 },
                                    1280: { slidesPerView: 3, spaceBetween: 32 },
                                },
                            });

                            gallerySwiper.on('reachBeginning reachEnd slideChange', function () {
                                updateNavButtons(gallerySwiper, prevEl, nextEl);
                            });
                            updateNavButtons(gallerySwiper, prevEl, nextEl);
                        }
                    }
                }

                // Initialize on load
                initSliderToGrid();

                // Initialize lightbox swiper (always available regardless of mobile/desktop)
                if (!!lightbox && !!swiperElementLightbox) {
                    // Store lightbox swiper element for later initialization
                }

                // Handle resize with debounce
                const handleResize = _debounce(() => {
                    initSliderToGrid();
                }, 250);

                window.addEventListener("resize", handleResize);

                // Setup lightbox functionality
                if (lightbox) {
                    const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');
                    const lightboxClose = lightbox.querySelector('[data-lightbox-close]');

                    // Close lightbox handlers
                    if (lightboxBackdrop) {
                        lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
                    }
                    if (lightboxClose) {
                        lightboxClose.addEventListener('click', () => closeLightBox(lightbox));
                    }

                    // Keyboard navigation (escape to close, arrows to navigate)
                    document.addEventListener('keydown', (event) => {
                        documentKeydownHandler(event, lightbox, galleryLightboxSwiper);
                    });
                }

                // Setup gallery thumbnail click handlers
                galleryThumbnails.forEach((thumbnail, index) => {
                    thumbnail.addEventListener('click', () => {

                        if (lightbox) {
                            // Initialize lightbox swiper if not already done
                            if (!galleryLightboxSwiper) {
                                // Temporarily make lightbox visible for proper slide detection
                                lightbox.style.visibility = 'hidden'; // Hidden but takes up space
                                lightbox.style.display = 'flex';
                                lightbox.classList.remove('hidden');
                                galleryLightboxSwiper = new Swiper(swiperElementLightbox, {
                                    effect: 'slide',
                                    // fadeEffect: { crossFade: false },
                                    speed: 750,
                                    loop: false,
                                    centeredSlides: true,
                                    resistanceRatio: 0,
                                    autoplay: false,
                                    allowTouchMove: true,
                                    slidesPerView: 1,
                                    spaceBetween: 0,
                                    width: null, // Let swiper calculate width
                                    watchOverflow: true,
                                    keyboard: {
                                        enabled: true,
                                        onlyInViewport: false,
                                    },
                                    navigation: {
                                        nextEl: lightbox.querySelector('.swiper-button-next'),
                                        prevEl: lightbox.querySelector('.swiper-button-prev'),
                                    },
                                    on: {
                                        init: function() {
                                            updateProgressBar(this, lightbox);

                                            // Hide lightbox again after initialization
                                            lightbox.style.visibility = '';
                                            lightbox.style.display = '';
                                            // Don't add hidden class back - let the data attributes control visibility
                                        },
                                        slideChange: function() {
                                            updateProgressBar(this, lightbox);
                                        }
                                    }
                                });
                            }

                            galleryLightboxSwiper.slideTo(index, 0);
                            openLightBox(lightbox);
                        }
                    });
                });

                // Sync lightbox with main gallery (if main gallery exists and is active)
                let syncing = false;
                if (galleryLightboxSwiper && gallerySwiper) {
                    galleryLightboxSwiper.on('slideChange', function () {
                        if (!syncing) {
                            syncing = true;
                            // Use slideTo for grid gallery (no loop)
                            if (gallerySwiper.slideTo) {
                                gallerySwiper.slideTo(galleryLightboxSwiper.realIndex, 0, false);
                            }
                            syncing = false;
                        }
                    });
                }
            }
        }
        // END GALLERY GRID PANEL

        // START EDITORIAL IMAGE SEQUENCE (residence detail page, editorial design bible 4.10)
        // Reuses the lightbox above: same markup, same open/close helpers, same Swiper config.
        // Thumbnails are links ([data-ed-lightbox-open]) so the page still works without JS.
        {
            const edLightbox = document.querySelector('[data-lightbox="residence-image-sequence"]');
            const edSwiperElement = edLightbox ? edLightbox.querySelector('.swiper[data-swiper-type="gallery-grid-lightbox-slider"]') : null;
            const edTriggers = document.querySelectorAll('[data-ed-lightbox-open]');

            if (edLightbox && edSwiperElement && edTriggers.length) {
                let edLightboxSwiper;
                let edLastTrigger = null;
                const edClose = edLightbox.querySelector('[data-lightbox-close]');
                const edBackdrop = edLightbox.querySelector('[data-lightbox-backdrop]');

                const edCloseLightbox = () => {
                    // Release the arrow keys for the page while the lightbox is closed
                    if (edLightboxSwiper && edLightboxSwiper.keyboard) edLightboxSwiper.keyboard.disable();
                    closeLightBox(edLightbox);
                    if (edLastTrigger) edLastTrigger.focus({ preventScroll: true });
                };

                if (edClose) edClose.addEventListener('click', edCloseLightbox);
                if (edBackdrop) edBackdrop.addEventListener('click', edCloseLightbox);

                document.addEventListener('keydown', (event) => {
                    if (event.key === 'Escape' && edLightbox.dataset.visible === 'true') edCloseLightbox();
                });

                edTriggers.forEach((trigger) => {
                    trigger.addEventListener('click', (event) => {
                        // Let modified clicks (new tab etc.) behave like a normal link
                        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
                        event.preventDefault();

                        edLastTrigger = trigger;

                        if (!edLightboxSwiper) {
                            // Temporarily make the lightbox take up space so Swiper can measure the slides
                            edLightbox.style.visibility = 'hidden';
                            edLightbox.style.display = 'flex';
                            edLightbox.classList.remove('hidden');
                            edLightboxSwiper = new Swiper(edSwiperElement, {
                                effect: 'slide',
                                speed: 750,
                                loop: false,
                                centeredSlides: true,
                                resistanceRatio: 0,
                                autoplay: false,
                                allowTouchMove: true,
                                slidesPerView: 1,
                                spaceBetween: 0,
                                width: null,
                                watchOverflow: true,
                                keyboard: {
                                    enabled: true,
                                    onlyInViewport: false,
                                },
                                navigation: {
                                    nextEl: edLightbox.querySelector('.swiper-button-next'),
                                    prevEl: edLightbox.querySelector('.swiper-button-prev'),
                                },
                                on: {
                                    init: function() {
                                        updateProgressBar(this, edLightbox);
                                        edLightbox.style.visibility = '';
                                        edLightbox.style.display = '';
                                    },
                                    slideChange: function() {
                                        updateProgressBar(this, edLightbox);
                                    }
                                }
                            });
                        }

                        edLightboxSwiper.slideTo(parseInt(trigger.dataset.edLightboxOpen, 10) || 0, 0);
                        if (edLightboxSwiper && edLightboxSwiper.keyboard) edLightboxSwiper.keyboard.enable();
                        openLightBox(edLightbox);
                        if (edClose) edClose.focus({ preventScroll: true });
                    });
                });
            }
        }
        // END EDITORIAL IMAGE SEQUENCE

        // START TESTIMONIAL PANEL SLIDER
        for (const panel of testimonialSliderPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="testimonial-slider"]');

            if (swiperElement) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="testimonial-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="testimonial-slider-${swiperIndex}"]`;

                const testimonialSwiper = new Swiper(swiperElement, {
                    loop: false,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: mobileSlidePerPage,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    pagination: {
                        el: `[data-swiper-pagination="testimonial-slider-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: mobileSlidePerPage,
                            spaceBetween: 24,
                        },
                        768: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 32,
                        },
                        1450: {
                            slidesPerView: 2,
                            spaceBetween: 32,
                        },
                    },
                });

                // Function to toggle navigation button visibility
                testimonialSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(testimonialSwiper, prevEl, nextEl);
                });

                updateNavButtons(testimonialSwiper, prevEl, nextEl);
            }
        }
        // END TESTIMONIAL PANEL SLIDER

        // START TESTIMONIAL PANEL FADER
        for (const panel of testimonialFaderPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="testimonial-fader"]');

            if (swiperElement) {
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="testimonial-fader-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="testimonial-fader-${swiperIndex}"]`;

                const testimonialSwiper = new Swiper(swiperElement, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    loop: true,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    pagination: {
                        el: `[data-swiper-pagination="testimonial-fader-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        },
                        1024: {
                            slidesPerView: 1,
                        },
                        1450: {
                            slidesPerView: 1,
                        },
                    },
                });

                // Function to toggle navigation button visibility
                testimonialSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(testimonialSwiper, prevEl, nextEl);
                });

                updateNavButtons(testimonialSwiper, prevEl, nextEl);
            }
        }
        // END TESTIMONIAL PANEL FADER

    }
});
